import { useState } from "react";
import { heroFeature, heroHotList } from "@/mocks/home";

export default function Hero() {
  const [inList, setInList] = useState(false);

  return (
    <section className="pb-10 pt-6 md:pb-14 md:pt-8">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h1 className="font-heading text-2xl leading-tight text-foreground-950 md:text-4xl">
              久久视频 · 免费影视资源站
            </h1>
            <p className="mt-2 max-w-3xl text-sm text-foreground-600 md:text-base">
              聚合免费电影、电视剧、高清影视与最新大片资源，覆盖热门网剧、综艺等多类内容，直接在在线播放列表里挑片看。
            </p>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 md:flex">
            <i className="ri-sparkling-line"></i>
            今日编辑推荐
          </span>
        </div>

        <div className="grid gap-4 md:gap-5 lg:grid-cols-12">
          <article className="relative overflow-hidden rounded-xl lg:col-span-8">
            <div className="relative h-[380px] md:h-[480px]">
              <img
                src={heroFeature.cover}
                alt={`${heroFeature.title} 免费在线观看 - 久久视频高清影视资源`}
                title={`${heroFeature.title} - 免费电影电视剧高清影视`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/50 to-foreground-950/10"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-fill"></i>
                  {heroFeature.badge}
                </span>
                <h2 className="mt-3 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
                  {heroFeature.title}
                </h2>
                <p className="mt-1 text-sm text-accent-300 md:text-base">{heroFeature.subtitle}</p>
                <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-background-200 md:text-sm">
                  <span className="flex items-center gap-1 font-medium text-accent-400">
                    <i className="ri-star-fill"></i>
                    {heroFeature.score}
                  </span>
                  <span>{heroFeature.meta}</span>
                </div>
                <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100/90 sm:block">
                  {heroFeature.desc}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {heroFeature.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-100/40 px-3 py-0.5 text-xs text-background-100"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-5 flex flex-wrap gap-3">
                  <button
                    type="button"
                    className="flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-play-fill text-lg"></i>
                    立即播放
                  </button>
                  <button
                    type="button"
                    onClick={() => setInList((v) => !v)}
                    className={`flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border px-5 text-sm font-medium transition-colors ${
                      inList
                        ? "border-accent-400 bg-accent-500 text-foreground-950"
                        : "border-background-100/50 text-background-50 hover:bg-background-50/10"
                    }`}
                  >
                    <i className={inList ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
                    {inList ? "已加入片单" : "加入片单"}
                  </button>
                </div>
              </div>
            </div>
          </article>

          <aside className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-4 md:p-5 lg:col-span-4">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-fire-fill text-primary-500"></i>
                热播榜
              </h3>
              <a
                href="#rankings"
                className="whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-700"
              >
                完整榜单
              </a>
            </div>
            <ul className="space-y-1">
              {heroHotList.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#rankings"
                    className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-50"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-sm ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-950 group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="block truncate text-xs text-foreground-500">
                        {item.episode}
                      </span>
                    </span>
                    <span className="font-heading text-sm text-accent-700">{item.score}</span>
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-auto rounded-lg bg-secondary-100 p-3 pt-3">
              <p className="flex items-start gap-1.5 text-xs leading-relaxed text-secondary-900">
                <i className="ri-information-line mt-0.5"></i>
                榜单每日 06:00 更新，依据站内播放、收藏与评论热度综合排序。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}